import axios from '@/store/axios.factory'

class ArrecadacaoService {
  arrecadacao () {
    return axios.get(`v1/arrecadacao`)
  }

  arrecadacaoPorCodigo (cdArrecadacao) {
    return axios.get(`v1/arrecadacao/${cdArrecadacao}`)
  }

  ativa () {
    return axios.get(`v1/arrecadacao/ativa`)
  }

  categoria () {
    return axios.get(`v1/arrecadacao/categoria`)
  }

  categoriaPorCodigo (cdCategoria) {
    return axios.get(`v1/arrecadacao/categoria/${cdCategoria}`)
  }

  comParamPorArrecadacao (cdArrecadacao) {
    return axios.get(`v1/arrecadacao/com-param-por-arrecadacao?cdArrecadacao=${cdArrecadacao}`)
  }

  comParamAtivaPorArrecadacao (cdCategoria) {
    return axios.get(`v1/arrecadacao/com-param-ativa-por-categoria?cdCategoria=${cdCategoria}`)
  }
}

export const arrecadacaoService = new ArrecadacaoService()
